export const SLOTS = {
  products: {
    id: 'search-results-page-products-gallery',
    displayName: 'Products Gallery',
  },
};
